// import { sourceToken } from '@/plugins/axios';

// 全局路由守卫
const routerBeforeEach = (to, from, next) => {
  // ...
  // if (from.name !== null) { // name 不为空，是跳转路由的状态而不是刷新的状态
  //   // 每次切换路由都取消上个路由未完成的请求
  //   sourceToken.cancel(' 撤销上个路由页面未完成的请求');
  // }
  next();
};

export default routerBeforeEach;

export {
  routerBeforeEach,
};
